import type { GhostBan } from "../types";
import { revokeGhostBanAction } from "./actions";
import { escapeHtml, formatDateTime } from "./format";

/**
 * Lista de IPs banidos da entrada como fantasma, comum ao painel do jogo e ao
 * /admin. Campos vazios (apelido, motivo) nao aparecem. O botao Remover leva
 * data-ghost-ban; quem renderiza liga os cliques com bindGhostBanButtons.
 */
export function ghostBanListHtml(bans: GhostBan[]): string {
  return (
    bans
      .map(
        (b) => `
      <li class="mod-row">
        <div class="mod-row-main">
          <div class="mod-who">
            <strong>${escapeHtml(b.ip)}</strong>
            ${b.ghostName ? `<span class="mod-handle">${escapeHtml(b.ghostName)}</span>` : ""}
            <span class="mod-handle">${formatDateTime(b.createdAt)}${b.issuedBy ? ` · por ${escapeHtml(b.issuedBy)}` : ""}</span>
            ${b.reason ? `<span class="mod-handle">“${escapeHtml(b.reason)}”</span>` : ""}
          </div>
          <button type="button" class="secondary small" data-ghost-ban="${b.id}">Remover</button>
        </div>
      </li>`,
      )
      .join("") || `<li class="empty">Nenhum IP banido</li>`
  );
}

/** Liga os botoes Remover; chama onDone com a mensagem de sucesso. */
export function bindGhostBanButtons(root: HTMLElement, token: string, bans: GhostBan[], onDone: (message: string) => void): void {
  root.querySelectorAll<HTMLButtonElement>("[data-ghost-ban]").forEach((button) =>
    button.addEventListener("click", async () => {
      const ban = bans.find((b) => String(b.id) === button.dataset.ghostBan);
      if (!ban) return;
      const result = await revokeGhostBanAction(ban, token);
      if (result !== null) onDone(result);
    }),
  );
}
